<template>
	<div class="ui-card" :class="{ shadow }" v-on="$listeners">
		<slot />
	</div>
</template>

<script>
export default {
	name: 'uiCard',
	props: {
		disabled: {
			type: Boolean,
			default: false,
		},
		loading: {
			type: Boolean,
			default: false,
		},
		shadow: {
			type: Boolean,
			default: true,
		},
	},
}
</script>

<style lang="less" scoped>
@import '../../assets/app.less';

.ui-card {
	flex-shrink: 0;
	height: fit-content;
	padding: 10px;
	background: #fff;
	border-radius: 16px;

	&.shadow {
		box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.1);
	}
}
</style>
